/**
 * Log-safe error identity for the file-transfer surfaces (#828 review, finding 2).
 *
 * `lib/log.ts`'s `logError`/`logWarn` serialize `err.message` into the console payload AND
 * forward the `Error` to Sentry; `packages/core`'s scrubber only redacts token/JWT/base64
 * SHAPES, not manifest fields — so a message embedding a file name or OPFS path would ship
 * verbatim. Every other surface in this codebase logs file-transfer failures by CLASS only
 * (`err.name` / `e.javaClass.simpleName`) for exactly that reason; this keeps the web on the
 * same invariant while preserving the original stack (code locations only, themselves scrubbed)
 * so Sentry stays useful.
 */
export function ftErrorIdentity(err: unknown): Error {
  const identity = new Error((err as Error)?.name ?? "unknown");
  if (err instanceof Error && err.stack !== undefined) identity.stack = err.stack;
  return identity;
}
